import { ComplaintsPage } from '@/complaints/components-list-view/complaints-page';
import { URL_NAVS } from '@/constants';
import { HelpWithRentascape } from '@/help/components/help-with-rentalscape';
import { useAnalytics } from '@/hooks/use-analytics';
import { ListViewerContainer } from '@/list/components/list-viewer/list-viewer-container';
import LegalPage from '@/login/cookie-policy';
import { PropertyDetailsPage } from '@/property-details/components/property-details-page';
import { UniversalSearchWrapper } from '@/search/components/universal-search-wrapper';
import { TOTView } from '@/top-level-tot/top-level-tot-view';
import { UserProfile } from '@/user/user-profile';
import { MapCardView } from '@/views/mapcard-view';
import { withDataLoading } from '@/widgets/components/with-data-loading';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { DashCardListContainer } from './dash-card-list';
import { Wrapper } from './dashboard-content-styles';
import { RootTabNotFound } from './root-tab-not-found';

// Apply the HOC to components that need property list and stats data
const DashCardListWithLoading = withDataLoading(DashCardListContainer);
const MapCardViewWithLoading = withDataLoading(MapCardView);
const ListViewerContainerWithLoading = withDataLoading(ListViewerContainer);
const TOTViewWithLoading = withDataLoading(TOTView);

const PropertyDetailsPageWithLoading = withDataLoading(PropertyDetailsPage, {
  withPropertyList: false,
});

const ComplaintsPageWithLoading = withDataLoading(ComplaintsPage);

const REGION_ROOT = '/:region';

/**
 * Renders the main content area of the dashboard based on the current route.
 */
export const DashboardRouter: React.FC = () => {
  useAnalytics();

  return (
    <Wrapper>
      <Switch>
        {/* Complaints route has to be the first route otherwise it will match the property details route */}
        <Route
          exact
          path={`${REGION_ROOT}/complaints/:complaintId?`}
          component={ComplaintsPageWithLoading}
        />
        <Route
          exact
          path={`${REGION_ROOT}/:tab/:propertyDeckardId/:propertyDetailsTab?`}
          component={PropertyDetailsPageWithLoading}
        />
        <Route
          exact
          path={`${REGION_ROOT}/${URL_NAVS.home}`}
          component={MapCardViewWithLoading}
        />
        <Route
          exact
          path={`${REGION_ROOT}/${URL_NAVS.list}`}
          component={ListViewerContainerWithLoading}
        />
        <Route
          exact
          path={`${REGION_ROOT}/${URL_NAVS['tax-reporting']}`}
          component={TOTViewWithLoading}
        />
        <Route
          exact
          path={`${REGION_ROOT}/${URL_NAVS.dashboard}`}
          component={DashCardListWithLoading}
        />
        <Route
          exact
          path={`${REGION_ROOT}/${URL_NAVS.help}`}
          component={HelpWithRentascape}
        />
        <Route
          exact
          path={`${REGION_ROOT}/${URL_NAVS.legal}`}
          component={LegalPage}
        />
        <Route
          exact
          path={`${REGION_ROOT}/${URL_NAVS.profile}`}
          component={UserProfile}
        />
        <Route component={RootTabNotFound} />
      </Switch>

      <UniversalSearchWrapper />
    </Wrapper>
  );
};
